module.exports = __webpack_public_path__ + "img/feature-tile-icon-02.04a67bd7.svg";